import { SAFE_MESSAGES } from '../../../shared/src/index';

export class HttpError extends Error {
  readonly status: number;
  readonly code: string;

  constructor(status: number, code: string, message: string) {
    super(message);
    this.name = 'HttpError';
    this.status = status;
    this.code = code;
  }
}

export class DestinationRejected extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'DestinationRejected';
  }
}

export class BusyError extends Error {
  constructor() {
    super(SAFE_MESSAGES.busy);
    this.name = 'BusyError';
  }
}
